<template>
  <div class="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 p-1.5">
    <div class="p-1.5" v-for="image in images">
      <nuxt-img class="w-full h-full"
                :src="image.src"
                :width="280"
                :height="279"
                loading="lazy"
                format="webp"
                sizes="xs:100px sm:190px md:231px lg:231px xl:280px 2xl:280px"
                :alt="image.alt"/>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  images: {
    type: Array,
    default: () => [
      {
        src: '/assets/images/image-1-line.jpg',
        alt: 'image-1'
      },
      {
        src: '/assets/images/image-2-line.jpg',
        alt: 'image-2'
      },
      {
        src: '/assets/images/image-3-line.jpg',
        alt: 'image-3'
      },
      {
        src: '/assets/images/image-4-line.jpg',
        alt: 'image-4'
      },
      {
        src: '/assets/images/image-5-line.jpg',
        alt: 'image-5'
      },
      {
        src: '/assets/images/image-6-line.jpg',
        alt: 'image-6'
      },

    ]
  }
})

defineBuilderComponent({
    friendlyName: "Images line",
    canHaveChildren: false,
    inputs: [
        {
            name: "images",
            type: "list",
            defaultValue: [
                {
                    src: "/assets/images/image-1-line.jpg",
                    alt: "image-1"
                },
                {
                    src: "/assets/images/image-2-line.jpg",
                    alt: "image-2"
                },
                {
                    src: "/assets/images/image-3-line.jpg",
                    alt: "image-3"
                },
                {
                    src: "/assets/images/image-4-line.jpg",
                    alt: "image-4"
                },
                {
                    src: "/assets/images/image-5-line.jpg",
                    alt: "image-5"
                },
                {
                    src: "/assets/images/image-6-line.jpg",
                    alt: "image-6"
                }
            ],
            subFields: [
                {
                    name: "src",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "webp"
                    ],
                    required: true,
                    defaultValue: ""
                },
                {
                    name: "alt",
                    type: "string",
                    defaultValue: ""
                }
            ]
        }
    ]
});
</script>